export default __webpack_public_path__ + "img/documentation.8b4fb87d.png";